// import React, { useContext, useEffect, useRef, useState } from "react";
// import MyPDF from "./myPdf";
// import { MyDocument2 } from "./template2";
// import { MyDocument3 } from "./template3";
// import { useUser } from "../../config/userProvider";
// import { FiDownload } from "react-icons/fi";
// import { VscFilePdf } from "react-icons/vsc";
// import { AiOutlineLoading3Quarters } from "react-icons/ai";


// import {
//   Document,
//   Page,
//   Text,
//   View,
//   StyleSheet,
//   PDFViewer,
//   Image,
//   Link,
// } from "@react-pdf/renderer";
// import {
//   PDFDownloadLink,
//   pdf,
//   Document as PDFDocument,
// } from "@react-pdf/renderer";
// import { saveAs } from "file-saver";
// import axios from "axios";
// import "./createCatalog.css";
// import PdfHeader from "./pdfHeader";
// import PdfFooter from "./pdfFooter";
// import TopBanner from "./topbanner.jpg";
// import FooterBanner from "./footerbanner.jpg";
// import { PdfContext } from "./pdfContext";
// import RunwayReady from "./runwayReady";
// import EleganceUnfolded from "./eleganceUnfolded";
// import TailoredTrends from "./tailoredTrends";
// import StyleChronicles from "./styleChronicles";
// import Blackberry from "./blackberry";
// import { useTheme } from "../../config/themeContext";

// // const downloadedData = async (data) => {
// //   const pdfData = await {
// //     Product: data?.Product,
// //     storeName: data?.Store?.storename,
// //     managerName: data?.Store?.managername,
// //     storePhone: data?.Store?.storePhone,
// //     storeAddress: data?.Store?.storeAdress,
// //     storeCode: data?.Store?.StoreCode,
// //   };
// //   axios({
// //     method: "post",
// //     url: "http://localhost:7000/analytic/create",
// //     payload: pdfData,
// //   })
// //     .then(function (response) {
// //       // handle success
// //     })
// //     .catch(function (error) {
// //       console.log(error);
// //     });
// // };


// const PDFComponent = ({ data, submitData, setPdfFile }) => {
//   const pdfRef = useRef();
//   const { choosedPdf, setchoosedPdf } = useContext(PdfContext);
//   const [isGenerating, setIsGenerating] = useState(false);
//   const [pdfUrl, setPdfUrl] = useState(null);
//   const { isPersonalize } = useUser();
//   console.log("isPersonalize from pdf component:", isPersonalize)
//   const { userData } = useUser();

//   console.log("LATESTDETAILS",data)


//   console.log("USERDATA IS:", userData)


//   const { vendor } = useTheme();

//   {
//     vendor && (console.log("VENDOR IS :", vendor)
//     )
//   }


//   // Function to get the appropriate document component

  
//  const getDocument = () => {
//   switch (choosedPdf) {
//     case "Modern-Muse":
//       return <MyDocument2 jsonData={data} vendor={vendor}/>;
//     case "Casual-Classics":
//       return <MyDocument3 jsonData={data} vendor={vendor}/>;
//     case "Style-Chronicles":
//       return <StyleChronicles jsonData={data} vendor={vendor}/>;
//     case "Blackberry":
//       return <Blackberry jsonData={data} vendor={vendor}/>;

//     case "Runway-Ready":
//       return <RunwayReady jsonData={data} vendor={vendor} />;
//     case "Elegance-Unfolded":
//       return <EleganceUnfolded jsonData={data} vendor={vendor} />;
//     case "Tailored-Trends":
//       return <TailoredTrends jsonData={data} vendor={vendor}/>;
//     default:
//       return <MyPDF jsonData={data} />;
//   }
// };
  

// useEffect(() => {
//   const generateFile = async () => {
//     try {
//       const PdfDocument = getDocument();
//       const blob = await pdf(PdfDocument).toBlob();
//       const file = new File([blob], getFileName(), { type: "application/pdf" });
//       console.log("Generated file:", file); // Debug
//       setPdfFile(file); // This should update the parent's state
//     } catch (error) {
//       console.error("PDF generation error:", error);
//     }
//   };
//   generateFile();
// }, [choosedPdf, setPdfFile]); // Add setPdfFile to dependencies

//   console.log("choosedPdf", choosedPdf);

//   const generatePdf = async () => {
//     try {
//       setIsGenerating(true);
//       const PdfDocument = getDocument();
//       const blob = await pdf(PdfDocument).toBlob();
//       // Convert blob to File object to upload
//       const file = new File([blob], getFileName(), {
//         type: "application/pdf",
//       });

//       setchoosedPdf(getFileName());
//       // Create FormData to send the file
//       const formData = new FormData();
//       formData.append("pdf", file);
//       submitData("catalog_downloaded");
//     } catch (error) {
//       console.error("PDF generation error:", error);
//     } finally {
//       setIsGenerating(false);
//     }
//   };

//   const getFileName = () => {
//     const fileNames = {
//       "Modern-Muse": "Modern-Muse.pdf",
//       "Casual-Classics": "Casual-Classics.pdf",
//       "Luxe-Looks": "Luxe-Looks.pdf",
//       "Style-Chronicles": "Style-Chronicles.pdf",

//       "Runway-Ready": "Runway-Ready.pdf",
//       "Elegance-Unfolded": "Elegance-Unfolded.pdf",
//       "Tailored-Trends": "Tailored-Trends.pdf",
//     };
//     return fileNames[choosedPdf] || "Products.pdf";
//   };

//   return (


//     <div className="flex text-center justify-end w-full">
//       {/* {userData?.servicesDetails?.catalogDownload === true ? ( */}
//         <PDFDownloadLink
//           document={getDocument()}
//           fileName={getFileName()}
//           onClick={() => generatePdf()}
//           className="bg-slate-800 text-white px-10 md:px-2 py-2 rounded-md mt-4"
//         >
//           {({ blob, url, loading, error }) =>
//             loading || isGenerating ? <AiOutlineLoading3Quarters className="animate-spin origin-center" />
//               : <FiDownload />
//           }
//         </PDFDownloadLink>
//       {/* ) : null} */}
//     </div>
//   );
// };

// export default PDFComponent;












import React, { useContext, useEffect, useRef, useState } from "react";
import MyPDF from "./myPdf";
import { MyDocument2 } from "./template2";
import { MyDocument3 } from "./template3";
import { useUser } from "../../config/userProvider";
import { FiDownload } from "react-icons/fi";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

import {
  PDFDownloadLink,
  pdf,
} from "@react-pdf/renderer";
import "./createCatalog.css";

import { PdfContext } from "./pdfContext";
import RunwayReady from "./runwayReady";
import EleganceUnfolded from "./eleganceUnfolded";
import TailoredTrends from "./tailoredTrends";
import StyleChronicles from "./styleChronicles";
import Blackberry from "./blackberry";
import { useTheme } from "../../config/themeContext";

/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

const PDFComponent = ({ data, submitData, setPdfFile }) => {
  const pdfRef = useRef(); // eslint-disable-line
  const { choosedPdf, setchoosedPdf } = useContext(PdfContext);
  const [isGenerating, setIsGenerating] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null); // eslint-disable-line

  const { isPersonalize } = useUser(); // eslint-disable-line
  const { userData } = useUser();

  const { vendor } = useTheme();

  // Function to get the appropriate document component
  const getDocument = () => {
    switch (choosedPdf) {
      case "Modern-Muse":
        return <MyDocument2 jsonData={data} vendor={vendor} />;
      case "Casual-Classics":
        return <MyDocument3 jsonData={data} vendor={vendor} />;
      case "Style-Chronicles":
        return <StyleChronicles jsonData={data} vendor={vendor} />;
      case "Blackberry":
        return <Blackberry jsonData={data} vendor={vendor} />;
      case "Runway-Ready":
        return <RunwayReady jsonData={data} vendor={vendor} />;
      case "Elegance-Unfolded":
        return <EleganceUnfolded jsonData={data} vendor={vendor} />;
      case "Tailored-Trends":
        return <TailoredTrends jsonData={data} vendor={vendor} />;
      default:
        return <MyPDF jsonData={data} />;
    }
  };

  useEffect(() => {
    const generateFile = async () => {
      try {
        const PdfDocument = getDocument();
        const blob = await pdf(PdfDocument).toBlob();
        const file = new File([blob], getFileName(), { type: "application/pdf" });
        setPdfFile(file);
      } catch (error) {
        console.error("PDF generation error:", error);
      }
    };
    generateFile();
  }, [choosedPdf, setPdfFile]); // eslint-disable-line react-hooks/exhaustive-deps

  const generatePdf = async () => {
    try {
      setIsGenerating(true);
      const PdfDocument = getDocument();
      const blob = await pdf(PdfDocument).toBlob();

      const file = new File([blob], getFileName(), {
        type: "application/pdf",
      });

      setchoosedPdf(getFileName());
      submitData("catalog_downloaded");
    } catch (error) {
      console.error("PDF generation error:", error);
    } finally {
      setIsGenerating(false);
    }
  };

  const getFileName = () => {
    const fileNames = {
      "Modern-Muse": "Modern-Muse.pdf",
      "Casual-Classics": "Casual-Classics.pdf",
      "Luxe-Looks": "Luxe-Looks.pdf",
      "Style-Chronicles": "Style-Chronicles.pdf",
      "Runway-Ready": "Runway-Ready.pdf",
      "Elegance-Unfolded": "Elegance-Unfolded.pdf",
      "Tailored-Trends": "Tailored-Trends.pdf",
    };
    return fileNames[choosedPdf] || "Products.pdf";
  };

  return (
    <div className="flex text-center justify-end w-full">
      <PDFDownloadLink
        document={getDocument()}
        fileName={getFileName()}
        onClick={() => generatePdf()}
        className="bg-slate-800 text-white px-10 md:px-2 py-2 rounded-md mt-4"
      >
        {({ loading }) =>
          loading || isGenerating ? (
            <AiOutlineLoading3Quarters className="animate-spin origin-center" />
          ) : (
            <FiDownload />
          )
        }
      </PDFDownloadLink>
    </div>
  );
};

export default PDFComponent;